<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('income')">
      <expense-action-button @open-modal="openModal" />
    </app-page-top-section>

    <!-- Search & Filter -->
    <div class="mb-3 d-flex gap-2 flex-wrap">
      <input
        type="text"
        v-model="search"
        @input="fetchIncomes"
        placeholder="Search by title"
        class="form-control"
      />

      <select v-model="filterMonth" @change="fetchIncomes" class="form-select">
        <option value="">All Months</option>
        <option v-for="(month, index) in months" :key="index" :value="index + 1">
          {{ month }}
        </option>
      </select>

      <select v-model="filterYear" @change="fetchIncomes" class="form-select">
        <option value="">All Years</option>
        <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
      </select>

      <select v-model="filterCategory" @change="fetchIncomes" class="form-select">
        <option value="">All Categories</option>
        <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
      </select>
    </div>

    <!-- Income Table -->
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>{{ $t('id') }}</th>
          <th>{{ $t('title') }}</th>
          <th>{{ $t('category') }}</th>
          <th>{{ $t('project') }}</th>
          <th>{{ $t('client') }}</th>
          <th>{{ $t('amount') }}</th>
          <th>{{ $t('date') }}</th>
           <th>{{ $t('reference') }}</th>
          <th>{{ $t('description') }}</th>
          <th>{{ $t('file') }}</th>
          <th>{{ $t('actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(income,index) in incomes.data" :key="income.id">
          <td>{{ (incomes.current_page - 1) * 10 + index + 1 }}</td>
          <td>{{ income.title }}</td>
          <td>{{ income.category ? income.category.name : '-' }}</td>
          <td>{{ income.project ? income.project.title : '-' }}</td>
          <td>{{ income.client ? income.client.name : '-' }}</td>
          <td>{{ income.amount }}</td>
         
           <td>{{ income.date }}</td>
            <td>{{ income.reference }}</td>
          <td>{{ income.description }}</td>
          <td>
            <div v-if="income.file">
              <!-- <a :href="`/incomes/${income.id}/download`" target="_blank">Download</a> -->
               <a :href="`/incomes/${income.id}/download`"  class="btn btn-sm btn-info">Download</a>
            </div>
            <div v-else>-</div>
          </td>
          <td>
            <a :href="`/incomes/${income.id}/invoice`" target="_blank" class="btn btn-sm btn-success">Invoice</a>
            <button class="btn btn-sm btn-primary" @click="editIncome(income)">Edit</button>
            <button class="btn btn-sm btn-danger" @click="deleteIncome(income.id)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Custom Pagination -->
    <nav v-if="incomes.last_page > 1">
      <ul class="pagination justify-content-center">
        <li
          class="page-item"
          :class="{ disabled: incomes.current_page === 1 }"
          @click="changePage(incomes.current_page - 1)"
        >
          <a class="page-link" href="#">Previous</a>
        </li>

        <li
          class="page-item"
          v-for="page in totalPages"
          :key="page"
          :class="{ active: incomes.current_page === page }"
          @click="changePage(page)"
        >
          <a class="page-link" href="#">{{ page }}</a>
        </li>

        <li
          class="page-item"
          :class="{ disabled: incomes.current_page === incomes.last_page }"
          @click="changePage(incomes.current_page + 1)"
        >
          <a class="page-link" href="#">Next</a>
        </li>
      </ul>
    </nav>

    <!-- Modal -->
    <expense-form-modal
      v-if="isModalActive"
      v-model="isModalActive"
      :income="selectedIncome"
      @saved="fetchIncomes"
    />
  </div>
</template>

<script>
import ExpenseActionButton from './Components/ExpenseActionButton.vue'
import ExpenseFormModal from './Components/ExpenseFormModal.vue'

export default {
  name: 'AppIncomes',
  components: { ExpenseActionButton, ExpenseFormModal },
  data() {
    return {
      incomes: { data: [], current_page: 1, last_page: 1 },
      categories: [],
      filterCategory: '',
      isModalActive: false,
      selectedIncome: null,
      search: '',
      filterMonth: '',
      filterYear: '',
      years: [],
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]
    }
  },
  mounted() {
    this.generateYears()
    this.fetchCategories()
    this.fetchIncomes()
  },
  computed: {
    totalPages() {
      let pages = []
      for (let i = 1; i <= this.incomes.last_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    fetchCategories() {
      axios.get('/incomes/categories')
        .then(res => { this.categories = res.data })
        .catch(err => console.error(err))
    },
    fetchIncomes(page = 1) {
      axios.get('/incomes', {
        params: {
          search: this.search,
          month: this.filterMonth,
          year: this.filterYear,
          category_id: this.filterCategory,
          per_page: 10,
          page: page
        }
      }).then(res => { this.incomes = res.data })
    },
    changePage(page) {
      if (page < 1 || page > this.incomes.last_page) return
      this.fetchIncomes(page)
    },
    openModal() {
      this.selectedIncome = null
      this.isModalActive = true
    },
    editIncome(income) {
      this.selectedIncome = income
      this.isModalActive = true
    },
    deleteIncome(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This will permanently delete this income entry.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`/incomes/${id}`).then(() => {
            this.fetchIncomes(this.incomes.current_page)
            Swal.fire({
              title: 'Deleted!',
              text: 'Income record has been deleted.',
              icon: 'success',
              confirmButtonColor: '#3085d6'
            })
          })
        }
      })
    },
    generateYears() {
      const currentYear = new Date().getFullYear()
      for (let i = currentYear; i >= currentYear - 10; i--) {
        this.years.push(i)
      }
    }
  }
}
</script>

<style>
.pagination .page-item.disabled .page-link {
  pointer-events: none;
  opacity: 0.5;
}
.pagination .page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}
</style>
